// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddTicketMessageData, AddTicketMessageErrors, AddTicketMessageResponses, CancelAccountDeletionData, CancelAccountDeletionErrors, CancelAccountDeletionResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailData, ConfirmEmailErrors, ConfirmEmailResponses, ConfirmMfaEnrollmentData, ConfirmMfaEnrollmentErrors, ConfirmMfaEnrollmentResponses, CreateTicketData, CreateTicketErrors, CreateTicketResponses, DeleteRecipeProgressData, DeleteRecipeProgressErrors, DeleteRecipeProgressResponses, DeleteRecipeTimerData, DeleteRecipeTimerErrors, DeleteRecipeTimerResponses, DeleteStarterData, DeleteStarterErrors, DeleteStarterLogData, DeleteStarterLogErrors, DeleteStarterLogResponses, DeleteStarterResponses, DisableMfaData, DisableMfaErrors, DisableMfaResponses, EnrollMfaData, EnrollMfaErrors, EnrollMfaResponses, ExportAccountData, ExportAccountErrors, ExportAccountResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAccountDeletionData, GetAccountDeletionErrors, GetAccountDeletionResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetMeData, GetMeErrors, GetMeResponses, GetRecipeData, GetRecipeErrors, GetRecipeProgressData, GetRecipeProgressErrors, GetRecipeProgressResponses, GetRecipeResponses, GetRecipeTimerData, GetRecipeTimerErrors, GetRecipeTimerResponses, GetStarterData, GetStarterErrors, GetStarterLogData, GetStarterLogErrors, GetStarterLogResponses, GetStarterResponses, GetTicketData, GetTicketErrors, GetTicketResponses, ListRecipeProgressData, ListRecipeProgressErrors, ListRecipeProgressResponses, ListRecipesData, ListRecipesErrors, ListRecipesResponses, ListRecipeTimersData, ListRecipeTimersErrors, ListRecipeTimersResponses, ListStarterLogsData, ListStarterLogsErrors, ListStarterLogsResponses, ListStartersData, ListStartersErrors, ListStartersResponses, ListTicketsData, ListTicketsErrors, ListTicketsResponses, PatchRecipeProgressData, PatchRecipeProgressErrors, PatchRecipeProgressResponses, PatchRecipeTimerData, PatchRecipeTimerErrors, PatchRecipeTimerResponses, PatchStarterData, PatchStarterErrors, PatchStarterLogData, PatchStarterLogErrors, PatchStarterLogResponses, PatchStarterResponses, PutRecipeProgressData, PutRecipeProgressErrors, PutRecipeProgressResponses, PutRecipeTimerData, PutRecipeTimerErrors, PutRecipeTimerResponses, PutStarterData, PutStarterErrors, PutStarterLogData, PutStarterLogErrors, PutStarterLogResponses, PutStarterResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterDevicePushTokenData, RegisterDevicePushTokenErrors, RegisterDevicePushTokenResponses, RequestAccountDeletionData, RequestAccountDeletionErrors, RequestAccountDeletionResponses, RequestMagicLinkData, RequestMagicLinkErrors, RequestMagicLinkResponses, ResendConfirmationData, ResendConfirmationErrors, ResendConfirmationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RevenueCatWebhookData, RevenueCatWebhookErrors, RevenueCatWebhookResponses, SetTicketStatusData, SetTicketStatusErrors, SetTicketStatusResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpData, SignUpErrors, SignUpResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, VerifyMagicLinkData, VerifyMagicLinkErrors, VerifyMagicLinkResponses, VerifyMfaData, VerifyMfaErrors, VerifyMfaResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Cancel a scheduled deletion
 */
export const cancelAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<CancelAccountDeletionData, ThrowOnError>): RequestResult<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Current deletion request, if any
 */
export const getAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<GetAccountDeletionData, ThrowOnError>): RequestResult<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Schedule the account for deletion
 */
export const requestAccountDeletion = <ThrowOnError extends boolean = false>(options: Options<RequestAccountDeletionData, ThrowOnError>): RequestResult<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError> => (options.client ?? client).post<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export all of the user's data
 */
export const exportAccount = <ThrowOnError extends boolean = false>(options?: Options<ExportAccountData, ThrowOnError>): RequestResult<ExportAccountResponses, ExportAccountErrors, ThrowOnError> => (options?.client ?? client).get<ExportAccountResponses, ExportAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/export',
    ...options
});

/**
 * Confirm an email address
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailData, ThrowOnError>): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError>({
    url: '/v1/auth/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the confirmation email
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(options: Options<ResendConfirmationData, ThrowOnError>): RequestResult<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError>({
    url: '/v1/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options
});

/**
 * Update the signed-in user
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn off two-factor authentication (needs an MFA-verified session)
 */
export const disableMfa = <ThrowOnError extends boolean = false>(options?: Options<DisableMfaData, ThrowOnError>): RequestResult<DisableMfaResponses, DisableMfaErrors, ThrowOnError> => (options?.client ?? client).post<DisableMfaResponses, DisableMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/disable',
    ...options
});

/**
 * Begin two-factor enrolment
 */
export const enrollMfa = <ThrowOnError extends boolean = false>(options?: Options<EnrollMfaData, ThrowOnError>): RequestResult<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError> => (options?.client ?? client).post<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll',
    ...options
});

/**
 * Confirm enrolment with a code
 */
export const confirmMfaEnrollment = <ThrowOnError extends boolean = false>(options: Options<ConfirmMfaEnrollmentData, ThrowOnError>): RequestResult<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish a two-factor sign-in
 */
export const verifyMfa = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaData, ThrowOnError>): RequestResult<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError> => (options.client ?? client).post<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError>({
    url: '/v1/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a sign-in link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>): RequestResult<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with an emailed token
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(options: Options<VerifyMagicLinkData, ThrowOnError>): RequestResult<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a password reset link
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using an emailed token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the refresh token
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke the current session
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/sign-out',
    ...options
});

/**
 * Create an account
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/v1/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a contact message
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>): RequestResult<SubmitContactResponses, SubmitContactErrors, ThrowOnError> => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/v1/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register this device for timer push notifications
 */
export const registerDevicePushToken = <ThrowOnError extends boolean = false>(options: Options<RegisterDevicePushTokenData, ThrowOnError>): RequestResult<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError> => (options.client ?? client).put<RegisterDevicePushTokenResponses, RegisterDevicePushTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/device-push-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send feedback
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: '/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness and database check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * List RecipeProgress rows (delta sync)
 */
export const listRecipeProgress = <ThrowOnError extends boolean = false>(options?: Options<ListRecipeProgressData, ThrowOnError>): RequestResult<ListRecipeProgressResponses, ListRecipeProgressErrors, ThrowOnError> => (options?.client ?? client).get<ListRecipeProgressResponses, ListRecipeProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-progress',
    ...options
});

/**
 * Delete a RecipeProgress (soft by default)
 */
export const deleteRecipeProgress = <ThrowOnError extends boolean = false>(options: Options<DeleteRecipeProgressData, ThrowOnError>): RequestResult<DeleteRecipeProgressResponses, DeleteRecipeProgressErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecipeProgressResponses, DeleteRecipeProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-progress/{id}',
    ...options
});

/**
 * Get one RecipeProgress
 */
export const getRecipeProgress = <ThrowOnError extends boolean = false>(options: Options<GetRecipeProgressData, ThrowOnError>): RequestResult<GetRecipeProgressResponses, GetRecipeProgressErrors, ThrowOnError> => (options.client ?? client).get<GetRecipeProgressResponses, GetRecipeProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-progress/{id}',
    ...options
});

/**
 * Update fields of a RecipeProgress
 */
export const patchRecipeProgress = <ThrowOnError extends boolean = false>(options: Options<PatchRecipeProgressData, ThrowOnError>): RequestResult<PatchRecipeProgressResponses, PatchRecipeProgressErrors, ThrowOnError> => (options.client ?? client).patch<PatchRecipeProgressResponses, PatchRecipeProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-progress/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a RecipeProgress (idempotent)
 */
export const putRecipeProgress = <ThrowOnError extends boolean = false>(options: Options<PutRecipeProgressData, ThrowOnError>): RequestResult<PutRecipeProgressResponses, PutRecipeProgressErrors, ThrowOnError> => (options.client ?? client).put<PutRecipeProgressResponses, PutRecipeProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-progress/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List RecipeTimer rows (delta sync)
 */
export const listRecipeTimers = <ThrowOnError extends boolean = false>(options?: Options<ListRecipeTimersData, ThrowOnError>): RequestResult<ListRecipeTimersResponses, ListRecipeTimersErrors, ThrowOnError> => (options?.client ?? client).get<ListRecipeTimersResponses, ListRecipeTimersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-timers',
    ...options
});

/**
 * Delete a RecipeTimer (soft by default)
 */
export const deleteRecipeTimer = <ThrowOnError extends boolean = false>(options: Options<DeleteRecipeTimerData, ThrowOnError>): RequestResult<DeleteRecipeTimerResponses, DeleteRecipeTimerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecipeTimerResponses, DeleteRecipeTimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-timers/{id}',
    ...options
});

/**
 * Get one RecipeTimer
 */
export const getRecipeTimer = <ThrowOnError extends boolean = false>(options: Options<GetRecipeTimerData, ThrowOnError>): RequestResult<GetRecipeTimerResponses, GetRecipeTimerErrors, ThrowOnError> => (options.client ?? client).get<GetRecipeTimerResponses, GetRecipeTimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-timers/{id}',
    ...options
});

/**
 * Update fields of a RecipeTimer
 */
export const patchRecipeTimer = <ThrowOnError extends boolean = false>(options: Options<PatchRecipeTimerData, ThrowOnError>): RequestResult<PatchRecipeTimerResponses, PatchRecipeTimerErrors, ThrowOnError> => (options.client ?? client).patch<PatchRecipeTimerResponses, PatchRecipeTimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-timers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a RecipeTimer (idempotent)
 */
export const putRecipeTimer = <ThrowOnError extends boolean = false>(options: Options<PutRecipeTimerData, ThrowOnError>): RequestResult<PutRecipeTimerResponses, PutRecipeTimerErrors, ThrowOnError> => (options.client ?? client).put<PutRecipeTimerResponses, PutRecipeTimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/recipe-timers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The recipe catalogue (public)
 */
export const listRecipes = <ThrowOnError extends boolean = false>(options?: Options<ListRecipesData, ThrowOnError>): RequestResult<ListRecipesResponses, ListRecipesErrors, ThrowOnError> => (options?.client ?? client).get<ListRecipesResponses, ListRecipesErrors, ThrowOnError>({ url: '/v1/recipes', ...options });

/**
 * One recipe (public)
 */
export const getRecipe = <ThrowOnError extends boolean = false>(options: Options<GetRecipeData, ThrowOnError>): RequestResult<GetRecipeResponses, GetRecipeErrors, ThrowOnError> => (options.client ?? client).get<GetRecipeResponses, GetRecipeErrors, ThrowOnError>({ url: '/v1/recipes/{id}', ...options });

/**
 * List StarterLog rows (delta sync)
 */
export const listStarterLogs = <ThrowOnError extends boolean = false>(options?: Options<ListStarterLogsData, ThrowOnError>): RequestResult<ListStarterLogsResponses, ListStarterLogsErrors, ThrowOnError> => (options?.client ?? client).get<ListStarterLogsResponses, ListStarterLogsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starter-logs',
    ...options
});

/**
 * Delete a StarterLog (soft by default)
 */
export const deleteStarterLog = <ThrowOnError extends boolean = false>(options: Options<DeleteStarterLogData, ThrowOnError>): RequestResult<DeleteStarterLogResponses, DeleteStarterLogErrors, ThrowOnError> => (options.client ?? client).delete<DeleteStarterLogResponses, DeleteStarterLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starter-logs/{id}',
    ...options
});

/**
 * Get one StarterLog
 */
export const getStarterLog = <ThrowOnError extends boolean = false>(options: Options<GetStarterLogData, ThrowOnError>): RequestResult<GetStarterLogResponses, GetStarterLogErrors, ThrowOnError> => (options.client ?? client).get<GetStarterLogResponses, GetStarterLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starter-logs/{id}',
    ...options
});

/**
 * Update fields of a StarterLog
 */
export const patchStarterLog = <ThrowOnError extends boolean = false>(options: Options<PatchStarterLogData, ThrowOnError>): RequestResult<PatchStarterLogResponses, PatchStarterLogErrors, ThrowOnError> => (options.client ?? client).patch<PatchStarterLogResponses, PatchStarterLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starter-logs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a StarterLog (idempotent)
 */
export const putStarterLog = <ThrowOnError extends boolean = false>(options: Options<PutStarterLogData, ThrowOnError>): RequestResult<PutStarterLogResponses, PutStarterLogErrors, ThrowOnError> => (options.client ?? client).put<PutStarterLogResponses, PutStarterLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starter-logs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Starter rows (delta sync)
 */
export const listStarters = <ThrowOnError extends boolean = false>(options?: Options<ListStartersData, ThrowOnError>): RequestResult<ListStartersResponses, ListStartersErrors, ThrowOnError> => (options?.client ?? client).get<ListStartersResponses, ListStartersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starters',
    ...options
});

/**
 * Delete a Starter (soft by default)
 */
export const deleteStarter = <ThrowOnError extends boolean = false>(options: Options<DeleteStarterData, ThrowOnError>): RequestResult<DeleteStarterResponses, DeleteStarterErrors, ThrowOnError> => (options.client ?? client).delete<DeleteStarterResponses, DeleteStarterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starters/{id}',
    ...options
});

/**
 * Get one Starter
 */
export const getStarter = <ThrowOnError extends boolean = false>(options: Options<GetStarterData, ThrowOnError>): RequestResult<GetStarterResponses, GetStarterErrors, ThrowOnError> => (options.client ?? client).get<GetStarterResponses, GetStarterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starters/{id}',
    ...options
});

/**
 * Update fields of a Starter
 */
export const patchStarter = <ThrowOnError extends boolean = false>(options: Options<PatchStarterData, ThrowOnError>): RequestResult<PatchStarterResponses, PatchStarterErrors, ThrowOnError> => (options.client ?? client).patch<PatchStarterResponses, PatchStarterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Starter (idempotent)
 */
export const putStarter = <ThrowOnError extends boolean = false>(options: Options<PutStarterData, ThrowOnError>): RequestResult<PutStarterResponses, PutStarterErrors, ThrowOnError> => (options.client ?? client).put<PutStarterResponses, PutStarterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/starters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List my tickets
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>): RequestResult<ListTicketsResponses, ListTicketsErrors, ThrowOnError> => (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options
});

/**
 * Open a ticket
 */
export const createTicket = <ThrowOnError extends boolean = false>(options: Options<CreateTicketData, ThrowOnError>): RequestResult<CreateTicketResponses, CreateTicketErrors, ThrowOnError> => (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One of my tickets with its conversation
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>): RequestResult<GetTicketResponses, GetTicketErrors, ThrowOnError> => (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}',
    ...options
});

/**
 * Add a note to a ticket
 */
export const addTicketMessage = <ThrowOnError extends boolean = false>(options: Options<AddTicketMessageData, ThrowOnError>): RequestResult<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError> => (options.client ?? client).post<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close or reopen a ticket
 */
export const setTicketStatus = <ThrowOnError extends boolean = false>(options: Options<SetTicketStatusData, ThrowOnError>): RequestResult<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError> => (options.client ?? client).post<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * RevenueCat server-to-server event
 */
export const revenueCatWebhook = <ThrowOnError extends boolean = false>(options: Options<RevenueCatWebhookData, ThrowOnError>): RequestResult<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError> => (options.client ?? client).post<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError>({
    url: '/v1/webhooks/revenuecat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
